import { render, staticRenderFns } from "./model6.vue?vue&type=template&id=0552566c&scoped=true"
import script from "./model6.vue?vue&type=script&lang=js"
export * from "./model6.vue?vue&type=script&lang=js"
import style0 from "./model6.vue?vue&type=style&index=0&id=0552566c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0552566c",
  null
  
)

export default component.exports